module.exports = __webpack_public_path__ + "4c360eebfc6d28d56c39258fbca88df6.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/left_hand/taco.png
// module id = 2440
// module chunks = 0